/** Parse order expression by splitting order field name and optional sort indicator. */
export const parseOrderExpression = (expression: string): [string, boolean] => {
  const parts = expression.trim().split(/\s+/);

  if (parts.length > 0) {
    return [parts[0].trim(), parts.length === 2 && parts[1].trim() === 'desc'];
  } else {
    return [expression.trim(), false];
  }
}